<ng-container *ngIf="item.visible !== false">
    <a pRipple tabindex="0" [id]="getMenuItemId()" [attr.data-menu-id]="item.id"
        class="text-sm flex py-3 align-items-center cursor-pointer menu-item transition-duration-150 transition-colors justify-content-center"
        [ngClass]="[root ? 'justify-content-center flex-column border-round root-menu-item':'justify-content-between border-round border-round-left-xl', isCurrentRoute && root ? 'active-menu border-bottom-1 border-top-1' : '', this.active ? 'selected' : '', isCollapsed ? 'isCollapsed' : 'isExpanded']"
        (click)="itemClick($event)" (keyup)="itemClick($event)">
        <ng-container *ngIf="root" [ngTemplateOutlet]="rootMenuTemplate">
        </ng-container>
        <ng-container *ngIf="!root" [ngTemplateOutlet]="submenuTemplate">
        </ng-container>
    </a>
    <ul #submenu [id]="getSubmenuId()" [attr.data-submenu-id]="item.id"
        [hidden]="!(item.items?.length > 0 && this.showSubmenu)" class="z-1 list-none p-0 min-w-max ml-3 mt-1"
        [@children]="submenuAnimation" (@children.done)="onSubmenuAnimated($event)">
        <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
            <li [id]="getChildMenuItemId(child.label || '')" [attr.data-list-item-id]="child.id">
                <app-menu-item [item]="child" [index]="i" [parentKey]="key" [parentItem]="this" class="submenu-item"
                    [isCollapsed]="isCollapsed" *ngIf="!isCollapsed"></app-menu-item>
            </li>
        </ng-template>
    </ul>
</ng-container>

<ng-template #rootMenuTemplate>
    <div class="flex w-full px-3">
        <div class="flex flex-1 align-items-center gap-3">
            <i class="pi font-bold text-4xl" *ngIf="item.icon" [ngClass]="item.icon"></i>
            <span class="text-lg" *ngIf="!isCollapsed">{{item.label}}</span>
        </div>
        <div class="flex align-items-center" *ngIf="!isCollapsed">
            <i class="pi pi-angle-down" [ngClass]="{'pi-angle-up': showSubmenu}" *ngIf="item.items"></i>
        </div>
    </div>
</ng-template>

<ng-template #submenuTemplate>
    <div class="flex w-full px-3">
        <div class="flex flex-1 align-items-center gap-3">
            <i class="pi font-bold text-4xl" *ngIf="item.icon" [ngClass]="item.icon"></i>
            <span>{{item.label}}</span>
        </div>
        <div class="flex align-items-center">
            <i class="pi pi-angle-down" [ngClass]="{'pi-angle-up': active}" *ngIf="item.items && !root"></i>
        </div>
    </div>
</ng-template>